(() => {
  const path = window.location.pathname.toLowerCase();
  const match = path.match(/^\/collections\/([^/?#]+)/);
  const handle = match ? decodeURIComponent(match[1]) : '';

  if (!handle.includes('erotica')) return;

  const style = document.createElement('style');
  style.textContent = `
    .olmarkt-agegate-lock{overflow:hidden!important}
    .olmarkt-agegate{position:fixed;inset:0;z-index:2147483647;background:rgba(9,10,12,.72);display:flex;align-items:center;justify-content:center;padding:20px}
    .olmarkt-agegate__panel{width:min(480px,100%);background:#fff;color:#171717;border-radius:10px;padding:24px;box-shadow:0 24px 80px rgba(0,0,0,.32);font-family:inherit}
    .olmarkt-agegate__panel h2{margin:0 0 10px;font-size:24px;line-height:1.2;letter-spacing:0}
    .olmarkt-agegate__panel p{margin:0 0 20px;font-size:15px;line-height:1.5}
    .olmarkt-agegate__actions{display:flex;gap:10px;flex-wrap:wrap}
    .olmarkt-agegate__yes,.olmarkt-agegate__no{appearance:none;border:0;border-radius:8px;padding:12px 16px;font-weight:700;cursor:pointer;font:inherit;min-height:44px}
    .olmarkt-agegate__yes{background:#111;color:#fff}
    .olmarkt-agegate__no{background:#eee;color:#111}
    @media(max-width:520px){.olmarkt-agegate__actions{display:grid}.olmarkt-agegate__yes,.olmarkt-agegate__no{width:100%}}
  `;
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.className = 'olmarkt-agegate';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'olmarkt-agegate-title');
  overlay.innerHTML = `
    <div class="olmarkt-agegate__panel">
      <h2 id="olmarkt-agegate-title">Ai peste 18 ani?</h2>
      <p>Aceasta categorie contine produse destinate exclusiv adultilor. Pentru a continua, confirma ca ai implinit 18 ani.</p>
      <div class="olmarkt-agegate__actions">
        <button type="button" class="olmarkt-agegate__yes">Da, am peste 18 ani</button>
        <button type="button" class="olmarkt-agegate__no">Nu, ies</button>
      </div>
    </div>
  `;

  const allow = () => {
    document.documentElement.classList.remove('olmarkt-agegate-lock');
    overlay.remove();
  };

  document.documentElement.classList.add('olmarkt-agegate-lock');
  document.body.appendChild(overlay);
  overlay.querySelector('.olmarkt-agegate__yes').addEventListener('click', allow);
  overlay.querySelector('.olmarkt-agegate__no').addEventListener('click', () => {
    window.location.href = '/';
  });
  overlay.querySelector('.olmarkt-agegate__yes').focus();
})();
